'use strict'

var create = require('./util/create')
var caseInsensitiveTransform = require('./util/case-insensitive-transform')

module.exports = create({
  space: 'xmlns',
  attributes: {
    xmlnsxlink: 'xmlns:xlink'
  },
  transform: caseInsensitiveTransform,
  properties: {
    xmlns: null,
    xmlnsXLink: null
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/hastscript/~/property-information/lib/xmlns.js
// module id = 204
// module chunks = 35783957827783 204390864267482 254791781388126